
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"23","height":"23","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#989AB2","stroke":"#989AB2","stroke-width":".3","d":"M.85 10v0c0 .239.095.468.264.636 0 0 0 0 0 0l11.25 11.25h0a.898.898 0 001.272 0h0l8.25-8.25h0a.898.898 0 000-1.272h0l-11.25-11.25A.89.89 0 0010 .85h0-8.25a.9.9 0 00-.9.9V10zm1.8-7.35h6.977L19.977 13 13 19.977 2.65 9.627V2.65z"}}),_c('path',{attrs:{"fill":"#989AB2","d":"M4 6.25a2.25 2.25 0 104.5 0 2.25 2.25 0 00-4.5 0zm3 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"}}),_c('path',{attrs:{"stroke":"#989AB2","d":"M4 6.25a2.25 2.25 0 104.5 0 2.25 2.25 0 00-4.5 0zm3 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"}})])
          )
        }
      }
    